import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCleanserGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M32.36 15.37H16.65c-1.46 0-2.65 1.18-2.65 2.64v19.34c0 1.46 1.19 2.65 2.65 2.65h15.71c1.46 0 2.64-1.19 2.64-2.64V18.01c0-1.46-1.19-2.64-2.64-2.64Zm1.14 21.98c0 .63-.51 1.14-1.14 1.14H16.65c-.63 0-1.15-.51-1.15-1.14V18.01c0-.63.51-1.15 1.15-1.15h15.71c.63 0 1.14.51 1.14 1.15v19.34ZM20.98 13.69c.41 0 .75-.34.75-.75V9.5h5.53v3.44c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.34-.75-.75-.75h-7.03c-.41 0-.75.34-.75.75v4.19c0 .41.34.75.75.75Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M25.97 24.73c-1.62 0-2.97 1.17-3.26 2.71-1.71.37-3 1.89-3 3.72 0 2.09 1.7 3.79 3.79 3.79s3.79-1.7 3.79-3.79c0-.02-.01-.04-.01-.06a3.33 3.33 0 0 0 2.01-3.04 3.32 3.32 0 0 0-3.32-3.33Zm-2.47 8.72c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29Zm3.44-3.87a3.819 3.819 0 0 0-2.67-2.14c.25-.7.92-1.21 1.71-1.21 1 0 1.82.82 1.82 1.82-.01.63-.34 1.2-.86 1.53ZM22.08 25.16c1.31 0 2.37-1.06 2.37-2.37s-1.06-2.37-2.37-2.37-2.37 1.06-2.37 2.37 1.06 2.37 2.37 2.37Zm0-3.24a.87.87 0 1 1-.001 1.741.87.87 0 0 1 .001-1.741Z",
    fill: "currentColor"
  }));
}

export { SvgCleanserGlyphSecondary as default };
